import React, {Component} from "react";
import Timer from "./Timer";
import ThemeSelector from "./ThemeSelector";
import {getNews} from "../redux/actions/news";
import {connect} from "react-redux";
import {Link, NavLink, withRouter} from "react-router-dom";
import {isAuth} from "../redux/actions/auth";
import $ from "jquery";

class TopMenu extends Component {
	intervalId = 0;

	componentWillMount() {
		// this.props.onGetNews('site', 50);
		this.intervalId = setInterval(this.isAuth.bind(this), 5000);
	}

	isAuth() {
		this.props.onIsAuth();
	}

	checkActive(match, location) {
		if ( !location ) {
			return false;
		}
		return location.pathname.indexOf('/news') !== -1;
	}

	openChat(e) {
		e.preventDefault();
		if ($('.globalClass_ET').length === 0){
			window.l();
		} else{
			$('.globalClass_ET').toggle();
			window.jivo_api.open();
		}
		/*e.preventDefault();
		const params = "menubar=no,location=yes,resizable=no,scrollbars=no,status=no,width=580,height=560";
		window.open("https://maxline.by/chat", "Чат", params);*/
	}

	goLine(e) {
		e.preventDefault();
		const {lineWidget} = this.props.line;
		const line = lineWidget.sports.map((sport) => sport.id).join('-');

		this.props.history.push(`/line-select/${line}`);
	}

	render() {
		const {news, viewedNews} = this.props;
		const unviewed = news.site.filter((item) => {return !(item.id in viewedNews)});

		return (
			<div className="topmenu" id="topmenu">
				<div className="container">
					<ul className="topmenu__items">
						<li className="topmenu__items__item">
							<NavLink exact to="/" className="topmenu__items__item__link">
								<i className="fas fa-home"></i>
							</NavLink>
						</li>
						<li className="topmenu__items__item ">
							<NavLink to="/live" className="topmenu__items__item__link">Live</NavLink>
						</li>
						<li className="topmenu__items__item ">
							<NavLink to="/line" className="topmenu__items__item__link" onClick={this.goLine.bind(this)}>Линия</NavLink>
						</li>
						<li className="topmenu__items__item with-sub">
							<NavLink to={"/result"} onClick={(e) => {e.preventDefault()}} className="topmenu__items__item__link">Результаты</NavLink>
							<ul className="submenu">
								<li><Link to={'/result/line'}>Результаты</Link></li>
								<li><Link to={'/result/live'}>Результаты Live</Link></li>
							</ul>
						</li>
						{/*<li className="topmenu__items__item ">*/}
							{/*<NavLink to='/statistic' className="topmenu__items__item__link">Статистика</NavLink>*/}
						{/*</li>*/}
						{/*<li className="topmenu__items__item with-sub">*/}
						{/*<NavLink to={'/betgames'} className="topmenu__items__item__link">BETGAMES</NavLink>*/}
						{/*<ul className="submenu">*/}
						{/*<li><a href="">7 из 42</a></li>*/}
						{/*<li><a href="">5 из 36</a></li>*/}
						{/*<li><a href="">Кости</a></li>*/}
						{/*<li><a href="">Колесо фортуны</a></li>*/}
						{/*<li><a href="">Покер</a></li>*/}
						{/*<li><a href="">Баккара</a></li>*/}
						{/*<li><a href="">Война ставок</a></li>*/}
						{/*</ul>*/}
						{/*</li>*/}
						{/*<li className="topmenu__items__item ">*/}
						{/*<a href="" className="topmenu__items__item__link">Финставки</a>*/}
						{/*</li>*/}
						<li className="topmenu__items__item ">
							<NavLink to={'/page/payments'} className="topmenu__items__item__link">Платежи</NavLink>
						</li>
						{/*<li className="topmenu__items__item ">*/}
							{/*<NavLink to={'/news/type/site'} activeClassName="active" isActive={this.checkActive.bind(this)} className="topmenu__items__item__link">*/}
								{/*<span>Новости</span>*/}
								{/*{unviewed.length > 0 &&*/}
								{/*<span className={'unviewed-news'}>{unviewed.length}</span>}*/}
							{/*</NavLink>*/}
						{/*</li>*/}
						{/*<li className="topmenu__items__item ">*/}
						{/*<a href="https://m.maxline.by/" className="topmenu__items__item__link">*/}
						{/*<i className="fas fa-mobile-alt"></i>*/}
						{/*</a>*/}
						{/*</li>*/}
					</ul>

					<div className="topmenu__service">
						<Timer/>
						{false && <ThemeSelector theme="default"/>}
					</div>
				</div>

			</div>
		);
	}
}

export default withRouter(
	connect(
		state => ({
			line       : state.line,
			auth       : state.auth,
			news       : state.news,
			viewedNews : state.viewedNews
		}),
		dispatch => ({
			onGetNews : (type, limit) => {
				dispatch(getNews(type, limit))
			},
			onIsAuth  : () => {
				dispatch(isAuth());
			}
		})
	)(TopMenu)
);




// WEBPACK FOOTER //
// ./src/app/components/TopMenu.js